// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// —————————————————————————————————————————— HDL. DEF. ——————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function stChH_navState(CHANGES) {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { navState } = CHANGES;
  if (this.options.log) console.warn("navState change", navState);

  //////////////////////////////////// State change execution ////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // menuOpen //
  ////////////////////////////////////

  if ("menuOpen" in navState) {
    const { menuOpen } = navState;
    const { btn_menu, menu, nav } = this.ref;

    if (btn_menu && menu) {
      btn_menu.setAttribute("data-active", menuOpen ? "true" : "false");
      menu.setAttribute("data-active", menuOpen ? "true" : "false");
    }

    if (nav) {
      nav.setAttribute("data-hidden", menuOpen ? "true" : "false");
    }
  }

  // back-to-top muted state //
  ////////////////////////////////////

  if ("backToTopMuted" in navState) {
    const { backToTopMuted } = navState;
    const { btn_backToTop } = this.ref;
    if (btn_backToTop) btn_backToTop.setAttribute("data-muted", backToTopMuted ? "true" : "false");
  }
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
